module.exports = __webpack_public_path__ + "66dd993c9920798f989b383894275efb.png";